'use client';

import type { AreaResponse } from '@/src/lib/api';
import { ListingSearchControls } from '@/src/components/ListingSearch/ListingSearch';
import { SearchFiltersProvider } from '@/src/components/ListingSearch/SearchFiltersProvider';

type HomepageListingSearchesProps = {
  initialArea?: AreaResponse | null;
  mobileClassName: string;
  desktopClassName: string;
};

export function HomepageListingSearches({
  initialArea,
  mobileClassName,
  desktopClassName,
}: HomepageListingSearchesProps) {
  return (
    <SearchFiltersProvider mode="navigate" nearMeArea={initialArea} seedFromRecentSearch>
      <div className={mobileClassName}>
        <ListingSearchControls size="lg" />
      </div>

      <div className={desktopClassName}>
        <ListingSearchControls size="lg" />
      </div>
    </SearchFiltersProvider>
  );
}
